import PropTypes from "prop-types";
import React from "react";

import { Image, StyleSheet, Text, View } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";

class IntroSlide extends React.Component {
  static propTypes = {
    content: PropTypes.string.isRequired,
    image: Image.propTypes.source.isRequired,
    title: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired
  };

  render() {
    const { content, image, themeColors, title, width } = this.props;

    return (
      <View style={[styles.container, { width }]}>
        <Image
          resizeMode="contain"
          source={image}
          style={[styles.image, { width: width - 60 }]}
        />
        <Text
          style={[
            styles.title,
            {
              color: themeColors.darkestPrimary
            }
          ]}
        >
          {title}
        </Text>
        <Text
          style={[
            styles.content,
            {
              color: themeColors.darkestPrimary
            }
          ]}
        >
          {content}
        </Text>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    padding: 30
  },
  content: {
    fontSize: 22,
    textAlign: "center",

    ...fonts.regular
  },
  image: {
    flex: 0.5,
    marginBottom: 40
  },
  title: {
    fontSize: 22,
    marginBottom: 10,
    textAlign: "center",

    ...fonts.bold
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(IntroSlide);
